/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
import {Model, ModelMixin} from '../../common/model.class';
import {InstitutionContact} from '../../education/common/values/institution-contact.class';
import {Address} from '../../common/values/address.class';
import {WorkDuration} from '../../common/values/work-duration.class';
import {LocumTenensInfo} from '../common/values/locum-tenens-info.class';

export class Work extends ModelMixin() implements Model<Work> {

    TYPE = Work;

    facility: string;
    contact: InstitutionContact = new InstitutionContact();
    address: Address = new Address();
    clinicalPosition: boolean;
    positionHeld: string;
    duration: WorkDuration = new WorkDuration();
    locumTenens: LocumTenensInfo = new LocumTenensInfo();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.duration) jsonData.duration = new WorkDuration(jsonData.duration);
        if (jsonData.locumTenens) jsonData.locumTenens = new LocumTenensInfo(jsonData.locumTenens);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/history/work.model.ts